import { useGtm, type GtmSupport, type TrackEventOptions } from "@gtm-support/vue-gtm";

export function useAnalytics() {
  const gtm = useGtm() as GtmSupport;

  const trackEvent = gtm.trackEvent.bind(gtm);

  return {
    gtm,
    trackEvent,
  };
}

export function trackAnalyticsEvent(input: TrackEventOptions) {
  try {
    const gtm = useGtm() as GtmSupport;
    return gtm.trackEvent(input);
  } catch (_error) {
    //
  }
}
